import React from "react";
import {
  IconBell,
  IconRobot,
  IconSettings,
} from "@tabler/icons-react";

// ===============================================
// CONFIGURAÇÕES
// ===============================================

const SETTINGS_FEATURES = [
  {
    icon: IconSettings,
    name: "Configurações Globais",
    desc: "Defina sua API Key padrão, preferências de IA e comportamentos gerais da plataforma",
  },
  {
    icon: IconBell,
    name: "Notificações de Atendimento Humano",
    desc: "Receba alertas no WhatsApp quando o agente solicitar suporte humano",
  },
  {
    icon: IconRobot,
    name: "Reativação Automática da IA",
    desc: "Reativa o agente automaticamente após atendimento humano",
  },
];

// ===============================================
// SETTINGS STEP COMPONENT
// ===============================================

const SettingsStep = () => {
  return (
    <>
      <div className="onb-card__header">
        <h2 className="onb-card__title">Configurações</h2>
        <p className="onb-card__subtitle">
          Personalize o funcionamento da plataforma
        </p>
      </div>

      <div className="onb-card__body">
        <p className="onb-card__text">
          No menu de <strong>Configurações</strong> você encontra opções
          importantes para personalizar a experiência da plataforma,
          incluindo notificações e comportamento dos agentes.
        </p>

        <div className="onb-menu-list">
          {SETTINGS_FEATURES.map((item, index) => (
            <div key={index} className="onb-menu-item">
              <div className="onb-menu-item__icon">
                <item.icon size={18} />
              </div>
              <div className="onb-menu-item__info">
                <span className="onb-menu-item__name">{item.name}</span>
                <span className="onb-menu-item__desc">{item.desc}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="onb-highlight">
          <IconBell size={18} className="onb-highlight__icon" />
          <span className="onb-highlight__text">
            Ative as notificações de atendimento humano para nunca perder
            um cliente que precisa de suporte pessoal.
          </span>
        </div>
      </div>
    </>
  );
};

export default SettingsStep;
